// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const avatarSize = "57px";

export const UserCardStyles = (config: DesignSystem) =>  ({
    userCardContainer: {
        position: "absolute",
        "z-index": "9999999999",
        display: "flex",
        padding: "8px",
        background: neutralLayerCard,
        color: neutralForegroundRest,
        "border-radius": "4px",
        "-webkit-box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.2), 0px 1.6px 12px rgba(0, 0, 0, 0.2)",
        "-moz-box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.2), 0px 1.6px 12px rgba(0, 0, 0, 0.2)",
        "box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.2), 0px 1.6px 12px rgba(0, 0, 0, 0.2)",

        "& .cwt-avatar": {
            height: avatarSize,
            "min-width": avatarSize,
            "max-width": avatarSize,
            margin: "6px 8px"
        },

        "& .cwt-user-info": {
            display: "flex",
            "flex-direction": "column",
            "min-width": "250px",
            margin: "6px 8px",

            "& .cwt-user-header": {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between",

                "& .cwt-name.cwt-link": {
                    "font-size": "20px",
                    "font-weight": "600",
                    color: neutralForegroundRest
                }
            },

            "& .cwt-user-stats": {
                display: "flex",
                "margin-top": "12px",

                "& .cwt-stat": {
                    display: "flex",
                    "flex-direction": "column",
                    "align-items": "center",
                    "justify-content": "flex-start",
                    [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "36px",

                    "&:first-child": {
                        [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0"
                    },

                    "& h6": {
                        "font-size": "13px",
                        "font-weight": "normal",
                        opacity: ".65"
                    },

                    "& .cwt-stat-counter": {
                        "margin-top": "4px",
                        "font-size": "13px",
                        "font-weight": "600"
                    }
                }
            }
        }
    },

    userCardPopover: {
        "z-index": "25000 !important"
    }
});